import ServiceExec from '@/common/utils/ServiceExec';
import { admin } from '@/common/service/ApiList';
import ConstCode from '@/common/constants/ConstCode';
import {toastAlert} from "@/common/utils/Toast";
const { LOGIN_TOKEN_NAME } = ConstCode;

const actions = {
  async login({ commit }, params) {
    const { headers, status, data } = await ServiceExec.post(admin.login, params);

    if (status == 200) {
      commit('setLoginData', data);
      commit('setAccessToken', headers[LOGIN_TOKEN_NAME]);
    }
    return { status, data };
  },
  async logout({ commit }) {
    const { data, response } = await ServiceExec.get(admin.logout);
    commit('setLoginData', {
      userId: '',
      name: '',
      email: ''
    });
    commit('setLoginData', '');
    commit('setAccessToken', '')
  },
  async changePassword({commit}, form)  {
    const {status, data}  = await ServiceExec.patch(admin.pwd, form)
    if(status === 200) {
      toastAlert("비밀번호 변경에 성공했습니다.", 'success')
      return true
    } else {
      toastAlert("비밀번호 변경에 실패했습니다.", 'error')
      return false
    }
  }
};

export default actions;
